<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="6" offset="3">
        <b-card header="Add a new client">
          <el-form
            :model="customerForm"
            :rules="rules"
            ref="newCustomerForm"
            label-width="160px"
            class="demo-settingsForm"
          >
            <h4>General</h4>
            <hr />
            <el-form-item label="Company:" prop="company">
              <el-input v-model="customerForm.company"></el-input>
            </el-form-item>

            <el-form-item label="First Name:" prop="firstName">
              <el-input v-model="customerForm.firstName"></el-input>
            </el-form-item>

            <el-form-item label="Last Name:" prop="lastName">
              <el-input v-model="customerForm.lastName"></el-input>
            </el-form-item>

            <el-form-item label="Email Address:" prop="email">
              <el-input v-model="customerForm.email"></el-input>
            </el-form-item>

            <el-form-item label="Phone Number:" prop="phone">
              <el-input v-model="customerForm.phone"></el-input>
            </el-form-item>

            <h4>Physical Address</h4>
            <hr />
            <el-form-item label="Street Address:" prop="address1">
              <el-input v-model="customerForm.address1"></el-input>
            </el-form-item>

            <el-form-item label="Street Address:" prop="address2">
              <el-input v-model="customerForm.address2"></el-input>
            </el-form-item>
            <el-form-item label="City:" prop="city">
              <el-input v-model="customerForm.city"></el-input>
            </el-form-item>
            <el-form-item label="State:" prop="state">
              <el-input v-model="customerForm.state"></el-input>
            </el-form-item>
            <el-form-item label="Zip:" prop="zip">
              <el-input v-model="customerForm.zip"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="saveCustomer()">Save</el-button>
            </el-form-item>
          </el-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from '../../shared/axios';
import { setTimeout } from 'timers';
export default {
  data() {
    return {
      customerForm: {
        company: undefined,
        firstName: undefined,
        lastName: undefined,
        email: undefined,
        address1: undefined,
        address2: undefined,
        city: undefined,
        state: undefined,
        zip: undefined
      },
      rules: {
        company: [
          {
            required: true,
            message: 'Please input a company name',
            trigger: 'blur'
          }
        ],
        firstName: [
          {
            required: true,
            message: "Please input the contact's first name",
            trigger: 'blur'
          }
        ],
        lastName: [
          {
            required: true,
            message: "Please input the contact's last name",
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: 'Please input email address',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    saveCustomer() {
      this.$refs['newCustomerForm'].validate(valid => {
        if (valid) {
          axios
            .post('client/add', this.customerForm)
            .then(r => {
              // success message
              this.$message({
                message: 'Created new client',
                type: 'success'
              });
              this.customerForm = {
                company: undefined,
                firstName: undefined,
                lastName: undefined,
                email: undefined,
                address1: undefined,
                address2: undefined,
                city: undefined,
                state: undefined,
                zip: undefined
              };
              setTimeout(() => {
                this.$router.push('/client/list');
              }, 1500);
            })
            .catch(e => {
              this.$message.error('Unable to create new client');
            });
        } else {
          this.$message.error('Form not completed filled out');
          return false;
        }
      });
    }
  }
};
</script>
